<template>
  <InspectionRecordsDetails/>
</template>
<script>
import InspectionRecordsDetails from 'operations/inspection/inspectionRecordsDetails.vue'
export default {
    components:{
      InspectionRecordsDetails
    }
}
</script>